export default "__VITE_ASSET__cfaf804f__"